import React, { useState, useCallback, useEffect } from 'react';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { logging, logPostInfo } from '../../../actions/log';
import styles from './index.module.less';
import Nav from '../Nav';
import Setup from './Setup';
import Collect from './Collect';
import Paylist from './Paylist';
import Turn from './Turn';
import { useDispatch, useSelector } from 'react-redux';
import { CONTEXT } from '../../../config';

import { createSelector } from 'reselect';
import { getVipState } from '../../../actions/wallpaperPay';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function WallpaperMine() {
  const history = useHistory();
  const [node, setNode] = useState(null);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [initTime, setInitTime] = useState(+new Date());

  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Mine',
        label: '',
        param2: {
          source: 'Wallpaper_Mine',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Wallpaper_Mine || setup',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
    dispatch(getVipState());
  }, []);

  return (
    <div
      className={`${styles.page} ${pathname === `${CONTEXT}/wpmine/turn` ? styles.page_turn : ''}`}
      ref={r => setNode(r)}
      pagescroll="PCStore_Page_Scroll"
    >
      <div className={styles.page_container}>
        <Switch>
          <Route exact path={`${CONTEXT}/wallpaper/wpmine/setup`}>
            <Setup node={node} />
          </Route>
          <Route exact path={`${CONTEXT}/wallpaper/wpmine/collect`}>
            <Collect node={node} />
          </Route>
          <Route exact path={`${CONTEXT}/wallpaper/wpmine/paylist`}>
            <Paylist node={node} />
          </Route>
          <Route exact path={`${CONTEXT}/wallpaper/wpmine/turn`}>
            <Turn node={node} />
          </Route>
          <Redirect to={`${CONTEXT}/wallpaper/wpmine/setup`} />
        </Switch>
      </div>
    </div>
  );
}

export default () => {
  return (
    <KeepAlive name="wpmine">
      <WallpaperMine />
    </KeepAlive>
  );
};
